import { useMemo } from 'react';
import { useAuthStore } from "../../stores/useAuthStore";
import { m } from '../../utils/dateUtils';

const DEFAULT_PERMISSIONS = {
    canPickyDate: false,
    canTripsOnly: false,
    canSelectProfiles: false,
    canSelectClients: false,
    canSelectDualMonitor: false,
    canLockVehicles: false,
    canAdjustTrips: false,
    canUseOperationalMap: false,

    minDate: null,

    dateRange: {
        minDays: 0,
        maxDays: 0
    },

    hourRangePerm: {
        minHour: 0,
        maxHour: 23,
        useOperationalRange: false
    }
};

export function usePermissions() {

    const capabilities = useAuthStore(
        state => state.user?.capabilities ?? DEFAULT_PERMISSIONS
    );

    const minAllowedDate = useMemo(() => {

        const twelveMonthsAgo = m()
            .subtract(12, 'months')
            .startOf('day');

        if (!capabilities.minDate) {
            return twelveMonthsAgo.format('YYYY-MM-DD');
        }

        const systemMinDate = m(capabilities.minDate)
            .startOf('day');

        const minDate = systemMinDate.isAfter(twelveMonthsAgo)
            ? systemMinDate
            : twelveMonthsAgo;

        return minDate.format('YYYY-MM-DD');

    }, [capabilities.minDate]);

    return {
        ...capabilities,
        minAllowedDate
    };
}